<div class="dropdown-body__item">
  @if (icon) {
    <i class="{{icon}}"></i>
  }
  <span>{{name}}</span>
</div>
